"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createVotesFilter = exports.createViewsFilter = exports.createUnreadByTeamFilter = exports.createTopicStatusFilter = exports.createStickyFilter = exports.createStatusFilter = exports.createRepliesFilter = exports.createPublishedInFilter = exports.createPublishedAtFilter = exports.createPublicTagFilter = exports.createProductAreaFilter = exports.createPinnedReplyFilter = exports.createModeratorTagFilter = exports.createModerationLabelFilter = exports.createLikesFilter = exports.createLastEditedAtFilter = exports.createLastActivityAtFilter = exports.createIdeationStatusFilter = exports.createContentTypeFilter = exports.createChangedIdeationStatusAtFilter = exports.createBugStatusFilter = exports.createBestAnswerFilter = exports.createAuthorFilter = exports.createAssignedModeratorFilter = void 0;

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _utils = require("@insided/deprecated-control/overview/filters/utils");

var _SimpleFilterSelector = _interopRequireDefault(require("@insided/deprecated-control/overview/filters/SimpleFilterSelector"));

var _DynamicFilterSelector = _interopRequireDefault(require("@insided/deprecated-control/overview/filters/DynamicFilterSelector"));

var _DateFilterSelector = _interopRequireDefault(require("@insided/deprecated-control/overview/filters/DateFilterSelector"));

var _RadioInputFilterSelector = _interopRequireDefault(require("@insided/deprecated-control/overview/filters/RadioInputFilterSelector"));

var _RadioFilterSelector = _interopRequireDefault(require("@insided/deprecated-control/overview/filters/RadioFilterSelector"));

var _string = require("@insided/deprecated-preact-components/utils/string");

var _contentType = require("@insided/shared/utils/contentType");

var _CategoryFilterSelector = _interopRequireDefault(require("@insided/deprecated-control/overview/filters/CategoryFilterSelector"));

var _ProductAreasFilterSelector = _interopRequireDefault(require("@insided/deprecated-control/overview/filters/ProductAreasFilterSelector"));

var _common = require("@insided/shared/utils/common");

var createPublishedInFilter = function createPublishedInFilter(categoriesV2) {
  return _CategoryFilterSelector.default.create({
    id: 'category',
    name: 'Published in',
    items: categoriesV2
  });
};

exports.createPublishedInFilter = createPublishedInFilter;

var getContentTypeDisplayName = function getContentTypeDisplayName(contentType) {
  var isBugContentTypeEnabled = _common.common.isModuleActive('bugContentType');

  if (contentType === 'conversation' && isBugContentTypeEnabled) {
    return 'Bug';
  }

  return "".concat(contentType.charAt(0).toUpperCase()).concat(contentType.replace(/([A-Z])/g, ' $1').slice(1));
};

var createContentTypeFilter = function createContentTypeFilter(contentTypes) {
  return _SimpleFilterSelector.default.create({
    id: 'contentType',
    name: 'Content type',
    items: contentTypes.map(function (contentType, idx) {
      return {
        id: idx,
        name: getContentTypeDisplayName(contentType),
        value: contentType
      };
    })
  });
};

exports.createContentTypeFilter = createContentTypeFilter;

var createAssignedModeratorFilter = function createAssignedModeratorFilter() {
  return _DynamicFilterSelector.default.create({
    id: 'assignedModerator',
    name: 'Assigned moderator',
    items: [{
      id: '',
      name: 'Unassigned',
      icon: 'user',
      value: ''
    }],
    fetchUrl: '/member/getModerators?query='
  });
};

exports.createAssignedModeratorFilter = createAssignedModeratorFilter;

var createPublicTagFilter = function createPublicTagFilter() {
  return _DynamicFilterSelector.default.create({
    id: 'publicTag',
    name: 'Public tag',
    items: [],
    isSearchable: true,
    fetchUrl: '/publicTag/list?query='
  });
};

exports.createPublicTagFilter = createPublicTagFilter;

var createAuthorFilter = function createAuthorFilter() {
  return _DynamicFilterSelector.default.create({
    id: 'author',
    name: 'Author',
    items: [],
    fetchUrl: '/member/getAuthors?filterByRole=1&query='
  });
};

exports.createAuthorFilter = createAuthorFilter;

var createModerationLabelFilter = function createModerationLabelFilter(moderationLabels) {
  return _SimpleFilterSelector.default.create({
    id: 'moderationLabel',
    name: 'Moderation label',
    items: [{
      id: '',
      name: '(No moderation label)',
      value: ''
    }].concat((0, _toConsumableArray2.default)(moderationLabels.map(function (moderationLabel) {
      return {
        id: moderationLabel.id,
        name: moderationLabel.title,
        value: moderationLabel.title
      };
    }))),
    isSearchable: true
  });
};

exports.createModerationLabelFilter = createModerationLabelFilter;

var createModeratorTagFilter = function createModeratorTagFilter() {
  return _DynamicFilterSelector.default.create({
    id: 'moderatorTag',
    name: 'Moderation tag',
    items: [],
    isSearchable: true,
    fetchUrl: '/overview/listModeratorTags?q='
  });
};

exports.createModeratorTagFilter = createModeratorTagFilter;

var createPublishedAtFilter = function createPublishedAtFilter() {
  return _DateFilterSelector.default.create({
    id: 'publishedAt',
    name: 'Publish date',
    items: (0, _utils.getDateSelectorItems)()
  });
};

exports.createPublishedAtFilter = createPublishedAtFilter;

var createLastActivityAtFilter = function createLastActivityAtFilter() {
  return _DateFilterSelector.default.create({
    id: 'lastActivityAt',
    name: 'Last activity date',
    items: (0, _utils.getDateSelectorItems)()
  });
};

exports.createLastActivityAtFilter = createLastActivityAtFilter;

var createLastEditedAtFilter = function createLastEditedAtFilter() {
  return _DateFilterSelector.default.create({
    id: 'lastEditedAt',
    name: 'Last edit date',
    items: (0, _utils.getDateSelectorItems)()
  });
};

exports.createLastEditedAtFilter = createLastEditedAtFilter;

var createChangedIdeationStatusAtFilter = function createChangedIdeationStatusAtFilter() {
  return _DateFilterSelector.default.create({
    id: 'changedIdeationStatusAt',
    name: 'Last ideation status change',
    items: (0, _utils.getDateSelectorItems)()
  });
};

exports.createChangedIdeationStatusAtFilter = createChangedIdeationStatusAtFilter;

var createIdeationStatusFilter = function createIdeationStatusFilter(ideationStatuses) {
  var isMain = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  return _SimpleFilterSelector.default.create({
    id: 'ideationStatus',
    name: 'Ideation status',
    items: ideationStatuses.map(function (ideationStatus) {
      return {
        id: ideationStatus.id,
        name: ideationStatus.name,
        value: ideationStatus.name
      };
    }),
    isSearchable: true,
    isMain: isMain
  });
};

exports.createIdeationStatusFilter = createIdeationStatusFilter;

var createBugStatusFilter = function createBugStatusFilter(bugStatuses) {
  var isMain = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  return _SimpleFilterSelector.default.create({
    id: 'bugStatus',
    name: 'Bug status',
    items: bugStatuses.map(function (bugStatus) {
      return {
        id: bugStatus.id,
        name: bugStatus.name,
        value: bugStatus.name
      };
    }),
    isSearchable: true,
    isMain: isMain
  });
};

exports.createBugStatusFilter = createBugStatusFilter;

var createRepliesFilter = function createRepliesFilter() {
  return _RadioInputFilterSelector.default.create({
    id: 'replies',
    name: 'Replies',
    items: (0, _utils.getRangeSelectorItems)()
  });
};

exports.createRepliesFilter = createRepliesFilter;

var createViewsFilter = function createViewsFilter() {
  return _RadioInputFilterSelector.default.create({
    id: 'views',
    name: 'Views',
    items: (0, _utils.getRangeSelectorItems)()
  });
};

exports.createViewsFilter = createViewsFilter;

var createLikesFilter = function createLikesFilter() {
  return _RadioInputFilterSelector.default.create({
    id: 'likes',
    name: 'Likes',
    items: (0, _utils.getRangeSelectorItems)()
  });
};

exports.createLikesFilter = createLikesFilter;

var createVotesFilter = function createVotesFilter() {
  return _RadioInputFilterSelector.default.create({
    id: 'votes',
    name: 'Votes',
    items: (0, _utils.getRangeSelectorItems)()
  });
};

exports.createVotesFilter = createVotesFilter;

var createBestAnswerFilter = function createBestAnswerFilter() {
  return _RadioFilterSelector.default.create({
    id: 'bestAnswer',
    name: 'Best answer',
    items: (0, _utils.getBooleanSelectorItems)()
  });
};

exports.createBestAnswerFilter = createBestAnswerFilter;

var createStickyFilter = function createStickyFilter() {
  return _RadioFilterSelector.default.create({
    id: 'sticky',
    name: 'Sticky Topic',
    items: (0, _utils.getBooleanSelectorItems)()
  });
};

exports.createStickyFilter = createStickyFilter;

var createPinnedReplyFilter = function createPinnedReplyFilter() {
  return _RadioFilterSelector.default.create({
    id: 'pinnedReply',
    name: 'Pinned reply',
    items: (0, _utils.getBooleanSelectorItems)()
  });
};

exports.createPinnedReplyFilter = createPinnedReplyFilter;

var createTopicStatusFilter = function createTopicStatusFilter() {
  return _RadioFilterSelector.default.create({
    id: 'closed',
    name: 'Closed for replies',
    items: [{
      id: 'no',
      name: 'No',
      value: false
    }, {
      id: 'yes',
      name: 'Yes',
      value: true
    }]
  });
};

exports.createTopicStatusFilter = createTopicStatusFilter;

var createUnreadByTeamFilter = function createUnreadByTeamFilter() {
  return _RadioFilterSelector.default.create({
    id: 'unreadByTeam',
    name: 'Unread by team',
    items: [{
      id: 1,
      name: 'Unread topic',
      value: 'unreadTopic'
    }, {
      id: 2,
      name: 'Unread reply',
      value: 'unreadReply'
    }, {
      id: 3,
      name: 'Unread topic or reply',
      value: 'unreadTopicOrReply'
    }, {
      id: 4,
      name: 'Read by team',
      value: 'read'
    }]
  });
};

exports.createUnreadByTeamFilter = createUnreadByTeamFilter;

var createProductAreaFilter = function createProductAreaFilter() {
  var isMain = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  var productAreas = arguments.length > 1 ? arguments[1] : undefined;
  return _ProductAreasFilterSelector.default.create({
    id: 'productArea',
    name: 'Product areas',
    items: [{
      id: '',
      name: '(No product area)',
      isSection: false,
      children: []
    }].concat((0, _toConsumableArray2.default)(productAreas)),
    isMain: isMain
  });
};

exports.createProductAreaFilter = createProductAreaFilter;

var createStatusFilter = function createStatusFilter() {
  var isMain = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  return _SimpleFilterSelector.default.create({
    id: 'status',
    name: 'Topic status',
    items: [_contentType.STATUS_PUBLISHED, _contentType.STATUS_SCHEDULED, _contentType.STATUS_DRAFT].map(function (status, idx) {
      return {
        id: idx,
        name: (0, _string.capitalize)(status),
        value: status
      };
    }),
    isMain: isMain
  });
};

exports.createStatusFilter = createStatusFilter;